import axios from "axios";

const gateways = [
  "https://cloudflare-ipfs.com/ipfs/",
  "https://gateway.pinata.cloud/ipfs/",
  "https://dweb.link/ipfs/",
  "https://ipfs.io/ipfs/",
  "https://teal-traditional-pig-34.mypinata.cloud/ipfs/"
];

export const getIpfsUrl = (url) => {
  if (!url) return "";
  const hash = url.replace("ipfs://", "");
  return `${gateways[0]}${hash}`; // 기본 게이트웨이 사용
};

export const getMetaFromTokenURI = async (tokenURI) => {
  if (!tokenURI) return null;

  const ipfsHash = tokenURI.replace("ipfs://", "");
  const urls = gateways.map((g) => `${g}${ipfsHash}`);

  for (const url of urls) {
    try {
      const headRes = await axios.head(url, { timeout: 5000 });
      const contentType = headRes.headers["content-type"];

      if (contentType && contentType.includes("application/json")) {
        const metaRes = await axios.get(url, { timeout: 5000 });
        return metaRes.data;
      } else if (contentType?.startsWith("image/")) {
        return { image: url };
      }
    } catch (err) {
      console.warn(`[getMetaFromTokenURI] 게이트웨이 실패: ${url}`, err.message);
    }
  }

  console.warn(`[getMetaFromTokenURI] 모든 게이트웨이 실패: ${tokenURI}`);
  return null;
};
